export default {
    PtProduct: { switch: '产品', mainPage: '首页' },
    PtHeader_products: {
        products: '产品',
        workspace: '工作空间',
        marketPlace: '导航库中心',
        analytics: '专利数据库',
        insights: '英策',
        bio: 'Bio',
        chemical: 'Chemical',
        cas: 'CAS',
        discovery: 'Discovery',
        synapse: '新药情报库',
        academy: '智慧芽学社',
        course: '智慧芽学社',
        course2b: '企业版学社',
        lab: 'PatSnap Lab',
        open: '数据服务平台',
        ipAsset: '资产管理',
        allProducts: '产品',
        tffi: 'TFFI',
        eureka: 'Eureka',
        pharmsnap: 'PharmSnap',
        yunchuang: '云创',
        innoCloud: 'INNOSNAP',
    },
};
